<template>
    <user-header></user-header>
    <div class="content">
        <router-view />
    </div>

    <user-footer></user-footer>
</template>

<script>
    import UserHeader from '@/components/header'
    import UserFooter from '@/components/footer'
    import AXIOS from '@/common/axios.js'
    import global from '@/common/global.js'

    export default {
        components: {
            UserHeader, UserFooter
        },
        data() {
            return {
                global,
            }
        },
        methods: {
            async getCurrentUser() {
                let data = new Object();
                let result = await AXIOS("/user/getCurrentUser", data);
                if (result.success) {
                    data.currentUser = result.data.currentUser;
                    data.rights = result.data.rights;
                    data.sid = result.data.sid;
                    data.token = result.data.token;
                } else {
                    console.log("/user/getCurrentUser occur error:" + result.errMsg);
                }
                return data;
            },
            toObject(rights) {
                let rightObj = new Object();
                console.log("rights ==> " + rights);
                if (rights.length > 2) {
                    rights = rights.substring(1, rights.length-1);
                    rights = rights.replace(/\",\"/g, ";").replace("\"", "");
                    let items = rights.split(";");
                    for (let i = 0; i < items.length; i++) {
                        let arr = items[i].split(":");
                        rightObj[arr[0]] = arr[1];
                    }
                }
                console.log("rightObj ==> " + rightObj);
                return rightObj;
            }
        },
        async mounted() {
            let token = localStorage.getItem("token");
            if (token && !this.global.currentUser) {
                let data = await this.getCurrentUser();
                if (data.currentUser) {
                    this.global.setCurrentUser(data.currentUser);
                    this.global.setToken(token);
                    this.global.setRights(data.rights);
                    let host = window.location.host;
                    if (host.indexOf("premia-partners.com") != -1)
                        host = "premia-partners.com";
                    else host = null;
                    this.global.setCookie("sid", data.sid, 0, "/", host);
                    console.log("set cookie:" + data.sid);
                } else {
                    this.global.setRights(null);
                    this.global.setCurrentUser(null);
                    this.global.setToken(null);
                    console.log("token:"+token + " is expired, need to re-login");
                    this.$router.push("/user/login");
                }
                // let rights = localStorage.getItem("rights");
                // let currentUser = localStorage.getItem("currentUser");
                // if (rights) {
                //     this.global.setCurrentUser(JSON.parse(currentUser));
                //     this.global.setRights(this.toObject(rights));
                //     this.global.setToken(token);
                // }
            }
        }
    }
</script>

<style scoped>
    .content {
        height: calc(100% - 92px);
    }
</style>
